import * as yup from 'yup';

import { ConsentDataModel, ConsentNameType } from '@nocowanie/common-ui';

export const consents: ConsentDataModel[] = [
    {
        id: ConsentNameType.SzallasTouristGDPR,
        isRequired: true,
        excerptTranslationKey: 'form.inputs.consents.SzallasTouristGDPR.excerpt',
        validationMessage: 'form.validationErrors.required',
    },
    {
        id: ConsentNameType.Profiling,
        isRequired: false,
        excerptTranslationKey: 'form.inputs.consents.Profiling.excerpt',
        expandedTextTranslationKey: 'form.inputs.consents.Profiling.expandedText',
        validationMessage: 'form.validationErrors.required',
    },
    {
        id: ConsentNameType.Mailing,
        isRequired: false,
        excerptTranslationKey: 'form.inputs.consents.Mailing.excerpt',
        expandedTextTranslationKey: 'form.inputs.consents.Mailing.expandedText',
        validationMessage: 'form.validationErrors.required',
    },
];

export const consentCheckboxSchema: Record<string, yup.Schema> = {};
for (const { id, isRequired } of consents) {
    consentCheckboxSchema[id] = yup.boolean().oneOf(isRequired ? [true] : [true, false]);
}
